// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7967":"0c6fd1ffc556e673","8808":"fedf84c3cea6b0b6"}[chunkId] + ".js";
};